import React from 'react';

import { Auth } from 'aws-amplify'

import AuthCard from './AuthCard';

import Grid from '@material-ui/core/Grid'
import TextField from '@material-ui/core/TextField'
import FormControl from '@material-ui/core/FormControl'
import Button from '@material-ui/core/Button'
import LinearProgress from '@material-ui/core/LinearProgress';

const strength = require('zxcvbn');

class PasswordResetHandler extends React.Component {
    state = {
        loading: false,
        password: '',
        code: '',
        helpText: "A password reset code has been emailed to you",
        helpTextClass: null
    }
    handleInputChange = e => {
        const { name, value } = e.target;
        this.setState({ [name]: value });
    }

    handleSubmit = e => {
        e.preventDefault();
        const { username } = this.props;
        const { password, code } = this.state;
        this.setState({ loading: true }, () => {
            Auth.forgotPasswordSubmit(username, code, password).then(data => {
                Auth.signIn(username, password).then(user => {
                    this.props.onStateChange('user_signin_complete')
                }).catch(err => console.log(err));
            }).catch(signInErr => {
                this.setState({ helpText: signInErr.message, helpTextClass: 'error' });
            });
        });
    }


    render() {
        const { loading, password, code, helpText, helpTextClass } = this.state;
        const passwordStrength = strength(password);
        return (
            <form onSubmit={this.handleSubmit}>
                <AuthCard loading={loading} {...this.props} title="Log in to Connect" subheader="Password Reset Requested"
                    helpText={helpText} helpTextClass={helpTextClass}>
                    <TextField
                        id="reset_code" name="code" value={code} autoComplete="off"
                        placeholder="Enter Reset Code" fullWidth autoFocus disabled={loading}
                        onChange={this.handleInputChange} margin="normal" type="text"
                    />
                    <Grid container spacing={24}>
                        <Grid item xs>
                            <TextField
                                id="login_password" name="password" value={password} autoComplete="off"
                                placeholder="Please enter a new password" fullWidth disabled={loading}
                                onChange={this.handleInputChange}
                                margin="normal" type="password"
                            />
                        </Grid>
                        <Grid item>
                            <FormControl margin="normal">
                                <Button variant="contained" color="secondary" disabled={loading} onClick={this.handleSubmit}>Go</Button>
                            </FormControl>
                        </Grid>
                    </Grid>
                    <LinearProgress variant="determinate" value={25 * passwordStrength.score} />
                </AuthCard>
            </form>
        )
    }
}
export default PasswordResetHandler;


// WEBPACK FOOTER //
// ./src/Components/Authentication/AuthParts/PasswordResetHandler.js